import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import * as BootstrapActions from '@app/main-store/bootstrap.actions';
import * as FeatureFlagsActions from '@app/main-store/feature-flags.actions';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, first, map, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MainLayoutGuard {
  private _actions$ = inject(Actions);
  private _store = inject(Store);

  canActivate(
    _activatedRouteSnapshot: ActivatedRouteSnapshot,
    _routerStateSnapshot: RouterStateSnapshot,
  ): Observable<boolean> {
    this._store.dispatch(BootstrapActions.loadCompanyBootstrap());
    this._store.dispatch(FeatureFlagsActions.loadCompanyFeatureFlags());

    return combineLatest([this.ofLoadCompanyBootstrap$(), this.ofLoadCompanyFeatureFlags$()]).pipe(
      timeout(10000),
      first(),
      map(() => true),
      catchError((error) => {
        console.error('Error loading required data:', error);
        return of(true);
      }),
    );
  }

  private ofLoadCompanyBootstrap$ = () =>
    this._actions$.pipe(
      ofType(BootstrapActions.loadCompanyBootstrapSuccess, BootstrapActions.loadCompanyBootstrapFailed),
      first(),
    );

  private ofLoadCompanyFeatureFlags$ = () =>
    this._actions$.pipe(
      ofType(FeatureFlagsActions.loadCompanyFeatureFlagsSuccess, FeatureFlagsActions.loadCompanyFeatureFlagsFailed),
      first(),
    );
}
